import React from 'react';

export default function CTA() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="cta" style={{
      position: 'relative', zIndex: 1, padding: '6rem 2rem',
      background: 'rgba(30,40,35,0.93)', overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute', right: '-10%', top: '-50%', width: 600, height: 600,
        border: '1px solid rgba(250,250,250,0.15)', borderRadius: '50%', pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', right: '5%', top: '-20%', width: 350, height: 350,
        border: '1px solid rgba(250,250,250,0.1)', borderRadius: '50%', pointerEvents: 'none'
      }} />

      <div className="cta-inner" style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'grid', gridTemplateColumns: '1fr auto', gap: '4rem',
        alignItems: 'center', position: 'relative', zIndex: 1
      }}>
        <div className="reveal-left">
          <h2 style={{
            fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
            textTransform: 'uppercase', lineHeight: 1, color: 'var(--dk)'
          }}>
            Turn Your<br />Dream House Into<br />Reality With Us.
          </h2>
          <p style={{ fontSize: '1rem', fontWeight: 500, color: 'rgba(250,250,250,0.65)', marginTop: '0.75rem', maxWidth: 480 }}>
            Starting from 2.5Lakh Affordable Price — residential, commercial, tensile, and PEB structures across Salem & Coimbatore.
          </p>
        </div>
        <div className="reveal-right" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', minWidth: 220 }}>
          <button onClick={() => scrollTo('#contact')}
            style={{
              background: 'var(--dk)', color: 'var(--wh)', fontFamily: 'var(--fh)',
              fontSize: '1rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
              padding: '0.85rem 2rem', border: 'none', cursor: 'pointer', transition: 'all .2s', whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--dk3)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--dk)'; e.currentTarget.style.transform = 'none'; }}>
            Request a Consultation
          </button>
          <a href="tel:+918056332329"
            style={{
              background: 'transparent', color: 'var(--dk)', fontFamily: 'var(--fh)',
              fontSize: '1rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
              padding: '0.85rem 2rem', border: '2px solid var(--dk)',
              textDecoration: 'none', display: 'block', textAlign: 'center', transition: 'all .2s', whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(250,250,250,0.1)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
            +91 80563 32329
          </a>
        </div>
      </div>
      <style>{`@media(max-width:900px){.cta-inner{grid-template-columns:1fr!important}}`}</style>
    </section>
  );
}
